import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadTeachers } from './actions';
import List from './List';
import { Panel } from 'react-bootstrap';

class Teachers extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const franchiseeId = this.props.franchiseeId;
		this.props.loadData({ franchiseeId, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleListEvent(listPagination) {
		const franchiseeId = this.props.franchiseeId;
		this.props.loadData({ franchiseeId, ...listPagination });
	}

	render() {
		return <Panel>
			<Panel.Body>
				<List franchiseeId={this.props.franchiseeId} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		entities: { teachers } } = state;

	const teachersPagination = pagination.teachersByFranchisee[ownProps.franchiseeId] || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: teachersPagination.ids.map(id => teachers[id]),
		pagination: teachersPagination
	};
};

Teachers.propTypes = {
	franchiseeId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	loadData: loadTeachers
})(Teachers);